import { colors } from '@puzzlio/tokens';
import type { HowToPlay } from '@puzzlio/core';
import type { StarsBoard } from './types';

export const howToPlay: HowToPlay = {
  game: 'stars',
  rules: ({ board }) => {
    const count = (board as StarsBoard | undefined)?.starsPerUnit ?? 2;
    return [
      {
        kind: 'steps',
        items: [
          `Place exactly ${count} ${count === 1 ? 'star' : 'stars'} in each row, each column, and each black bordered region.`,
          'Stars cannot touch, not even diagonally.',
        ],
      },
    ];
  },
  cycle: [
    { fill: colors['white'] },
    { fill: colors['white'], glyph: 'cross' },
    { fill: colors['white'], glyph: 'star' },
    { fill: colors['white'] },
  ],
};
